import { createContext } from "react";

/**
 * How much horizontal room sits between a table's columns.
 *
 * A context rather than a prop threaded through TableHeaderCell_ and the memoized TableRow_,
 * matching how PanelContext and PageEdgeContext already reach the same cells.
 */
export const ColumnSpacingContext = createContext<"default" | "wide">(
  "default",
);
